export const STORAGE_KEY = 'authRedirect'
export const DEFAULT_REDIRECT = '/'
export const REDIRECT_QUERY_PARAM = 'redirectURL'



// WEBPACK FOOTER //
// ./src/app/auth/constants.ts